var baseUrl = 'https://topworking.vn'
// var baseUrl = 'http://dktt.topcv.local'

export const getWeatherApi = () =>  {
    return $.ajax({
        type: "GET",
        url: "https://api.openweathermap.org/data/2.5/forecast?id=1581130&APPID=46f356d9b700e8bbde333ed372811c49&units=metric&lang=vi",
        dataType: "json",
    });
}


export const getQrApi = () =>  {
    var url = baseUrl + '/api/dashboard/get-qr';
    let data = {
        region: 2
    }
    return $.ajax({
        data: data,
        type: "GET",
        url: url,
        dataType: "json",
    })
}


export const getNewsApi = () =>  {
    var url = baseUrl + '/api/dashboard/lastest-news';
    // var url = 'http://dktt.topcv.local/api/dashboard/lastest-news';
    let data = {
        region: 2
    }
    return $.ajax({
        data: data,
        type: "GET",
        url: url,
        dataType: "json",
    })
}


export const getBirthdayApi = () =>  {
    var url = baseUrl + '/api/dashboard/birthday-user';
    let data = {
        region: 2
    }
    return $.ajax({
        data: data,
        type: "GET",
        url: url,
        dataType: "json",
    })
}

export const getUserStatisticApi = () =>  {
    var url = baseUrl + '/api/dashboard/count';
    let data = {
        region: 2
    }
    return $.ajax({
        data: data,
        type: "GET",
        url: url,
        dataType: "json",
    })
}

export const getRankingApi = () => {
    var url = baseUrl + '/api/dashboard';
    let data = {
        region: 2
    }
    return $.ajax({
      data: data,
      type: "GET",
      url: url,
      dataType: "json",
    })
}

export const getVoiceUrlApi = (text) => {
    var url = baseUrl + '/api/dashboard/get-voice?voice=' + text;
    return $.ajax({
      type: "GET",
      url: url,
      dataType: "json",
    })
}


export const getWakeUpSongApi = (text) => {
    var url = baseUrl + '/api/dashboard/wakeup-song';
    // var url = 'http://dktt.topcv.local/api/dashboard/wakeup-song';/
    let data = {
        region: 2
    }
    return $.ajax({
        data: data,
      type: "GET",
      url: url,
      dataType: "json",
    })
}






// WEBPACK FOOTER //
// ./src/api/api.js